export const visibilityCommunityStatus = [
    {
        id: 1,
        value : "Publique"
    },
    {
        id: 2,
        value : "Privée"
    }
]

export const activityFilters = [
    {
        id: 'future',
        value: "Activités à venir"
    },
    {
        id: 'past',
        value:"Activités passée"
    }
]

export const locationFilters = [
    {
        id: 'future',
        value: "Location à venir"
    },
    {
        id: 'past',
        value:"Location passée"
    }
]

export const openTrainingFilters = [
    {
        id: 'future',
        value: 'OpenTraining à venir'
    },
    {
        id: 'past',
        value: 'OpenTraining passé'
    }
]